/* eslint-disable import/prefer-default-export */
export const LIST_LOOKER_URLS = 'LIST_LOOKER_URLS';
export const LIST_KEY_METRICS_URLS = 'LIST_KEY_METRICS_URLS';
